/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "./tags";
import * as i3 from "ionic-angular/navigation/nav-controller";
import * as i4 from "ionic-angular/navigation/nav-params";
var styles_TagsPage = [];
var RenderType_TagsPage = i0.ɵcrt({ encapsulation: 2, styles: styles_TagsPage, data: {} });
export { RenderType_TagsPage as RenderType_TagsPage };
function View_TagsPage_1(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "span", [["class", "badge badge-warning badge-tag"]], null, null, null, null, null)), (_l()(), i0.ɵted(1, null, [" ", "\n"]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); }); }
export function View_TagsPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵand(16777216, null, null, 1, null, View_TagsPage_1)), i0.ɵdid(1, 802816, null, 0, i1.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.tags; _ck(_v, 1, 0, currVal_0); }, null); }
export function View_TagsPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "comp-tags", [], null, null, null, View_TagsPage_0, RenderType_TagsPage)), i0.ɵdid(1, 49152, null, 0, i2.TagsPage, [i3.NavController, i4.NavParams], null, null)], null, null); }
var TagsPageNgFactory = i0.ɵccf("comp-tags", i2.TagsPage, View_TagsPage_Host_0, { tags: "tags" }, {}, []);
export { TagsPageNgFactory as TagsPageNgFactory };
//# sourceMappingURL=tags.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/tags/tags.ngfactory.js
// module id = null
// module chunks = 